<template>
  <div class="domain-list">
    <b-card no-body class="border-0 shadow-sm">
      <!-- Üst Bar: Arama, Filtre ve Sayaçlar -->
      <b-card-header class="bg-white border-bottom py-3">
        <b-row align-v="center" class="gy-2 w-100">
          <!-- Arama Inputu -->
          <b-col md="4" sm="12">
            <b-input-group size="sm">
              <template #prepend>
                <b-input-group-text>
                  <i class="feather icon-search"></i>
                </b-input-group-text>
              </template>
              <b-form-input
                v-model="search"
                type="search"
                placeholder="Firma veya domain ara..."
              />
            </b-input-group>
          </b-col>

          <!-- v-select: Hosting Sağlayıcı Filtresi -->
          <b-col md="3" sm="6">
            <v-select
              v-model="selectedProvider"
              :options="providerOptions"
              class="custom-vue-select"
              :reduce="opt => opt.value"
              label="label"
              placeholder="Tüm Sağlayıcılar"
            />
          </b-col>

          <!-- Yenile Butonu & Sayaçlar -->
          <b-col md="5" sm="6" class="d-flex justify-content-md-end align-items-center ">
            <b-badge variant="danger" class="p-1 text-white mr-1">
              Biten: {{ countExpired }}
            </b-badge>
            <b-badge variant="warning" class="py-1 text-dark mr-1">
              ≤30 Gün: {{ countExpiringSoon }}
            </b-badge>
            <b-button size="sm" variant="outline-secondary" :disabled="loading" @click="fetchDomains">
              <b-spinner v-if="loading" small />
              <div v-else class="d-flex align-items-center">
              <feather-icon icon="RefreshCcwIcon" class="mr-1" />
              <span>Yenile</span>
              </div>
            </b-button>
          </b-col>
        </b-row>
      </b-card-header>

      <!-- Tablo Alanı -->
      <b-card-body class="p-0">
        <b-table
          hover
          responsive
          show-empty
          :items="filteredDomains"
          :fields="fields"
          :busy="loading"
          head-variant="light"
          class="mb-0 text-nowrap align-middle"
          empty-text="Kayıt bulunamadı."
        >
          <!-- Loading Slot -->
          <template #table-busy>
            <div class="text-center my-2 text-muted">
              <b-spinner small class="mr-1"  />
              <span>Veriler yükleniyor...</span>
            </div>
          </template>

          <!-- Müşteri Bilgisi -->
          <template #cell(customer_name)="row">
            <div class="font-weight-bold text-dark">{{ row.item.customer_name }}</div>
            <small class="text-muted">ID: #{{ row.item.customer_id }}</small>
          </template>

          <!-- Platform -->
          <template #cell(platform_name)="row">
            <b-badge variant="secondary" pill class="font-weight-normal px-2 py-1">
              {{ row.item.platform_name || 'Tanımsız' }}
            </b-badge>
          </template>

          <!-- Domain Linki -->
          <template #cell(domain_name)="row">
            <a
              :href="'http://' + row.item.domain_name"
              target="_blank"
              rel="noopener noreferrer"
              class="text-primary font-weight-bold text-decoration-none"
            >
              {{ row.item.domain_name }}
            </a>
          </template>

          <!-- Hosting Sağlayıcı -->
          <template #cell(hosting_provider)="row">
            <b-badge
              :variant="row.item.hosting_provider === 'bulutino' ? 'primary' : 'dark'"
              class="px-2 py-1"
            >
              {{ row.item.hosting_provider || 'Bilinmiyor' }}
            </b-badge>
          </template>

          <!-- Kayıt Tarihi -->
          <template #cell(registered_at)="row">
            <span>{{ formatDate(row.item.registered_at || row.item.customer_created_at) }}</span>
          </template>

          <!-- Bitiş Tarihi -->
          <template #cell(expires_at)="row">
            <span>{{ formatDate(row.item.expires_at) }}</span>
          </template>

          <!-- Kalan Süre Rozeti -->
          <template #cell(days_left)="row">
            <b-badge :variant="getDaysVariant(row.item.days_left)" class="px-2 py-1">
              {{ formatDaysText(row.item.days_left) }}
            </b-badge>
          </template>

          <!-- İşlemler / Yenile Butonu -->
          <template #cell(actions)="row">
            <b-button
              size="sm"
              variant="outline-primary"
              @click="openRenewModal(row.item)"
            >
              Yenile
            </b-button>
          </template>
        </b-table>
      </b-card-body>
    </b-card>
    <!-- Domain Süre Yenileme Modalı -->
    <b-modal
      id="renew-modal"
      v-model="showRenewModal"
      title="Domain Süresini Yenile"
      ok-title="Kaydet ve Güncelle"
      cancel-title="İptal"
      :ok-disabled="renewLoading"
      @ok="handleRenewSubmit"
    >
      <div v-if="activeDomain">
        <b-alert show variant="info" class="py-2 mb-2">
          <strong>{{ activeDomain.domain_name }}</strong> ({{ activeDomain.customer_name }})
        </b-alert>

        <b-form-group label="Yeni Başlangıç Tarihi:" label-for="renew-start-date">
          <b-form-input
            id="renew-start-date"
            v-model="renewForm.startDate"
            type="date"
            required
          />
        </b-form-group>
        <b-form-group label="Yenileme Süresi (Yıl):" label-for="renew-years">
         
         <v-select
          v-model="renewForm.years"
          placeholder="Yıl Seçin"
          :options="[1, 2, 3, 4, 5, 10]"
          :clearable="false"
          class="custom-vue-select"
        />
        </b-form-group>

        <div class="mt-2 text-secondary">
          Yeni Bitiş Tarihi: <strong>{{ computedExpiresAt }}</strong>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { BCard, BCardHeader, BCardBody, BRow, BCol, BInputGroup, BInputGroupText, BFormInput, BButton, BSpinner, BTable, BBadge, BFormGroup, BForm } from 'bootstrap-vue';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';


export default {
  name: 'DomainList',
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BRow,
    BCol,
    BInputGroup,
    BFormGroup,
    BInputGroupText,
    BFormInput,
    BButton,
    BSpinner,
    BTable,
    BBadge,
    vSelect
  },
  data() {
    return {
      domains: [],
      loading: false,
      search: '',
      selectedProvider: null,
      providerOptions: [
        { label: 'Bulutino', value: 'bulutino' },
        { label: 'Diğer', value: 'other' }
      ],
      fields: [
        { key: 'customer_name', label: 'Firma / Müşteri', sortable: true },
        { key: 'platform_name', label: 'Platform', sortable: true },
        { key: 'domain_name', label: 'Domain', sortable: true },
        { key: 'hosting_provider', label: 'Register', sortable: true },
        { key: 'registered_at', label: 'Kayıt Tarihi', sortable: true },
        { key: 'expires_at', label: 'Bitiş Tarihi', sortable: true },
        { key: 'days_left', label: 'Kalan Gün / Durum', sortable: true },
        { key: 'actions', label: 'İşlemler', sortable: false }
      ],
      // Modal yönetimi
      showRenewModal: false,
      renewLoading: false,
      activeDomain: null,
      renewForm: {
        domainId: null,
        startDate: '',
        years:1
      }
    };
  },
  computed: {
    filteredDomains() {
      const q = (this.search || '').toLowerCase().trim();

      return this.domains.filter(item => {
        const matchText =
          (item.customer_name && item.customer_name.toLowerCase().includes(q)) ||
          (item.domain_name && item.domain_name.toLowerCase().includes(q));

        const matchProvider =
          !this.selectedProvider || item.hosting_provider === this.selectedProvider;

        return matchText && matchProvider;
      });
    },
    countExpired() {
      return this.domains.filter(d => Number(d.days_left) < 0).length;
    },
    countExpiringSoon() {
      return this.domains.filter(d => Number(d.days_left) >= 0 && Number(d.days_left) <= 30).length;
    },
    computedExpiresAt() {
      if (!this.renewForm.startDate) return '-';
      const d = new Date(this.renewForm.startDate);
      d.setFullYear(d.getFullYear() + 1);
      return d.toLocaleDateString('tr-TR');
    }
  },
  created() {
    this.fetchDomains();
  },
  methods: {
    fetchDomains() {
      this.loading = true;
      this.$http.get('manage/domains')
        .then(res => {
          if (res.data && res.data.success) {
            this.domains = res.data.data;
          }
        })
        .catch(err => {
          console.error('Domain listesi hatası:', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    getDaysVariant(days) {
      const d = Number(days);
      if (d < 0 || d <= 15) return 'danger';
      if (d <= 30) return 'warning';
      return 'success';
    },

    openRenewModal(item) {
      this.activeDomain = item;
      this.renewForm.domainId = item.id;

      // Eğer süresi çoktan geçmişse bugünü öner, henüz bitmemişse mevcut bitiş tarihini başlangıç yap
      const today = new Date().toISOString().split('T')[0];
      if (Number(item.days_left) < 0) {
        this.renewForm.startDate = today;
      } else {
        this.renewForm.startDate = item.expires_at ? item.expires_at.split('T')[0] : today;
      }

      this.showRenewModal = true;
    },

    handleRenewSubmit(bvModalEvt) {
      // Modalın hemen kapanmasını engelle
      bvModalEvt.preventDefault();

      if (!this.renewForm.startDate) return;

      this.renewLoading = true;
      const payload = {
        domain_id: parseInt(this.renewForm.domainId) ,
        start_date: this.renewForm.startDate,
        years: this.renewForm.years || 1 // 1 yıl ekleme
      };

      this.$http.put('manage/domains/renew', payload)
        .then(res => {
          if (res.data && res.data.success) {
            this.showRenewModal = false;
            this.fetchDomains(); // Listeyi güncelle
          } else {
            alert(res.data.error || 'İşlem başarısız.');
          }
        })
        .catch(err => {
          console.error('Yenileme hatası:', err);
        })
        .finally(() => {
          this.renewLoading = false;
        });
    },
    
    formatDaysText(days) {
      const d = Number(days);
      if (d < 0) return `${Math.abs(d)} gün önce bitti`;
      if (d === 0) return 'Bugün doluyor!';
      return `${d} gün kaldı`;
    },

    formatDate(dateVal) {
      if (!dateVal) return '-';
      const d = new Date(dateVal);
      return d.toLocaleDateString('tr-TR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      });
    }
  }
};
</script>

<style scoped>
.v-select-sm .vs__dropdown-toggle {
  min-height: 31px;
  font-size: 0.875rem;
}
</style>